<template>
  <div class="text-[14px] leading-[22px] text-gray-800">
    <p>
      <template v-if="isWebPlan">
        Looks like you purchased this subscription on Dacr.com. You'll need to
        manage your subscription there.
      </template>

      <template v-else>
        Looks like you purchased this subscription on your
        {{ platform }} device using in-app payments. You'll need to manage your
        subscription from that platform.
      </template>
    </p>

    <Alert v-if="!webviewStore.isActive" variant="success" class="mt-5">
      <span class="font-medium">Save money</span>
      by cancelling your subscription on that platform and resubscribe on
      Dacr.com.
    </Alert>
  </div>
</template>

<script setup lang="ts">
import { Alert } from '@dacr/library'

import { useWebviewStore } from '@/shared/stores/webview'
import { useIAP, type IAPType } from './useIAP'

const props = defineProps<{
  type: IAPType
}>()

const webviewStore = useWebviewStore()
const { platform, isWebPlan } = useIAP(props.type)
</script>
